<template>
    <div>
        <rkm-area title="Procedimentos Feridas">
            <rkm-row>
                <rkm-col cols="12">
                    <List
                        :data="data"
                        @edit="$refs.Modal.open($event)"
                        @remove="remove"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <Modal
            :data="modalData"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from '../../../../../ferida/components/procedimento/Modal'
import repository from '@/mixins/repository'

export default {
    components: {
        List,
        Modal,
    },
    mixins: [repository],
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento')
        }
    },
    computed: {
        modalData() {
            return {
                ...this.data,
                soap: { id: this.data.additionals.soapId },
                procedimentos: this.data.model.procedimentosFeridas,
                feridaModel: (this.data.feridaModel && this.data.feridaModel.feridas) ? this.data.feridaModel.feridas : [],
            }
        },
    },
    methods: {
        remove(item, index) {
            const remove = () => {
                
                this.data.model.procedimentosFeridas.splice(index, 1)

                const feridaId = item.ferida_id || item.atendimentoSoapFeridaId || item.feridaId

                if (feridaId && this.data.feridaModel && this.data.feridaModel.feridas) {
                    const ferida = this.data.feridaModel.feridas.find(f => f.id === feridaId)

                    if (ferida && ferida.procedimentos) {
                        const procedimentoIndex = ferida.procedimentos.findIndex(p => p.id === item.id)

                        if (procedimentoIndex !== -1) {
                            ferida.procedimentos.splice(procedimentoIndex, 1)
                        }
                    }
                }
            }

            if (item.id) {
                this.repositories.atendimento.destroyFeridaProcedimento(item.id)
                    .then(() => {
                        remove()
                    })
                    .catch(error => {
                        const mensagem = error.response?.data?.message || 'Erro ao remover procedimento.'
                        this.showValidationNotification ? 
                            this.showValidationNotification(mensagem) : 
                            this.showAlert(mensagem)
                    })
            } else {
                remove()
            }
        }
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
